module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box"
  }, [(false) ? _c('van-dropdown-menu', [_c('van-dropdown-item', {
    attrs: {
      "options": [{
        text: '全部商品',
        value: 0
      } ]
    }
  }), _vm._v(" "), _c('van-dropdown-item', {
    attrs: {
      "options": [{
        text: '全部商品',
        value: 0
      } ]
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, [_c('div', {
    staticClass: "kaojicenter-list-box"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      staticClass: "kaojicenter-lists flex-between",
      on: {
        "click": function($event) {
          return _vm.action(item, index)
        }
      }
    }, [_c('div', {
      staticClass: "kaojicenter-lefts"
    }, [_c('img', {
      staticClass: "img",
      attrs: {
        "src": item.pic_url,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "kaojicenter-rights"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "desc flex-start"
    }, [_vm._v("\n                                 " + _vm._s(item.num) + "\n                            ")])])])
  }), 0)])], 1), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.onMemberAdd
    }
  }, [_vm._v("新增")])], 1) : _vm._e(), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45897db1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/cba/CbaApplyMemberList.vue
// module id = 2352
// module chunks = 0